import React, { useState, useEffect, useRef } from 'react';
import style from './CustomDiseaseSetting.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import { useNavigate } from "react-router-dom";

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import Skeleton from '@mui/material/Skeleton';

const CustomDiseaseSetting = () => {

    const navigate = useNavigate();

    const isSendingRef = useRef(false);
    const [dissInfoList, setDissInfoList] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // 상태 추가

    useEffect(() => {
        getDissInfoList();
    }, []);

    // 체크된 목록 불러오기
    const getDissInfoList = async () => {

        setIsLoading(true);
    
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

        const url = "/homecare/disease/retrieveUsrCstmzDissInfoList";
        const reqBody = {
            usrInfoId : loginUser.usrInfoId
        }
        try {
            const res = await axiosApi.post(url, reqBody);
            
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const dissInfoList = res.data.result.dissInfoList || [];
                setDissInfoList(dissInfoList);
            } else {
                setDissInfoList([]);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };
 
   
    return (
        <>
            <HeadSub title="맞춤 질환 정보 설정" />
 
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['content-box']}>
                        <div className={style['btn-box']}>
                            <button className='btn' data-btn-type="fill-main" data-btn-size='sm' 
                                onClick={() => {
                                    const checkedList = dissInfoList?.map(({ hblNo, dissNm }) => ({
                                        hblNo,
                                        dissNm
                                    }));
                                    navigate(URL.DISEASE_SETTING, { state: { checkedList : checkedList } });
                                }}
                            >
                                <span>설정하기</span>
                            </button>
                        </div>
                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>맞춤 질환 1</p>
                                    <div className={style['right']}>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{dissInfoList[0] ? dissInfoList[0].dissNm: '설정 안됨'}</span>
                                        )}
                                    </div>
                                </li>
                                <li>
                                    <p>맞춤 질환 2</p>
                                    <div className={style['right']}>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{dissInfoList[1] ? dissInfoList[1].dissNm: '설정 안됨'}</span>
                                        )}
                                    </div>
                                </li>
                                <li>
                                    <p>맞춤 질환 3</p>
                                    <div className={style['right']}>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{dissInfoList[2] ? dissInfoList[2].dissNm: '설정 안됨'}</span>
                                        )}
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className={style['bot-list-box']}>
                            <ul>
                                <li>
                                    <span>
                                        맞춤 질환 설정 시 홈 케어 &gt; 맞춤 질환 정보 탭에서 설정한 질환에 대한 다양한 콘텐츠를 확인하실 수 있습니다. 
                                        <button className={style['link-btn']} onClick={()=> navigate(URL.DISEASE_SETTING)}>&#91; 바로가기 &#93;</button> 
                                    </span>
                                    
                                </li>
                                <li>
                                    <span>맞춤 질환은 최대 3개까지 설정 가능합니다. </span>
                                </li>
                            </ul>
                        </div>
                    </div>
 

                </div>
            </div>
        </>
    );
};

export default CustomDiseaseSetting;
